import BaseUseCase from "../../../base_use_case.js";

class ShowDeveloperUseCase extends BaseUseCase {

  execute(identifier) {
    return this.httpClient({
      ...this.requestConfig(),
      method: "get",
      url: `/api/v1/admin/projects/developers/${identifier}`,
    });
  }
}

const instance = new ShowDeveloperUseCase();
export default instance;